import React from 'react';

import { useFormContext } from 'react-hook-form';
import { useSelector } from 'react-redux';

import { isEqual, merge } from 'lodash-es';
import PropTypes from 'prop-types';

import * as ScenarioStore from '@asteria/datalayer/stores/scenarios';

import { formatResponse, validateFormValues } from '../utils';

function isEmptyData(data) {
	return !Object.keys(data ?? {}).length;
}

/**
 * @type { React.FC<{ history: unknown, yearHistory: unknown, forecast: unknown, scenario: unknown }> }
 */
const FormUpdater = React.memo(function FormUpdater(props) {
	const { history, yearHistory, scenario } = props;

	const { getValues, reset } = useFormContext();

	const sourceScenarioData = useSelector(
		ScenarioStore.selectors.sourceScenarioData,
		isEqual,
	);

	React.useEffect(() => {
		if (
			isEmptyData(history?.data) ||
			isEmptyData(yearHistory?.data) ||
			isEmptyData(scenario?.data)
		) {
			return;
		}

		const data = merge(
			{},
			formatResponse(history?.data ?? {}),
			formatResponse(yearHistory?.data ?? {}),
			{
				allOperations: scenario?.data?.operations ?? [],
			},
		);

		const changes = getValues('changes') ?? [];

		const next = validateFormValues(data, sourceScenarioData);

		next.changes = changes;
		next.allOperations = [...next.allOperations, ...changes];

		reset(next, {
			keepDefaultValues: false,
			keepValues: false,
			keepDirty: false,
			keepDirtyValues: false,
			keepErrors: false,
			keepTouched: false,
			keepSubmitCount: false,
			keepIsSubmitSuccessful: false,
			keepIsValid: false,
		});
	}, [
		getValues,
		history?.data,
		reset,
		sourceScenarioData,
		yearHistory?.data,
		scenario?.data,
	]);

	return null;
});

FormUpdater.propTypes = {
	history: PropTypes.object,
	yearHistory: PropTypes.object,
	scenario: PropTypes.object,
};

export default FormUpdater;
